import { createFeatureSelector } from '@ngrx/store';

export const appSettingsState = createFeatureSelector<OLO.State, OLO.State.AppSettings>('appSettings');
